/** @format */

/**
 * External dependencies
 */
import { get, merge } from 'lodash';

/**
 * Internal dependencies
 */
import { ERROR } from '../constants';
import { serializeQueryArgs } from '../utils';

const DEFAULT_STATE = {
};

export default function availabilityReducer( state = DEFAULT_STATE, action ) {
	const queryKey = serializeQueryArgs( action.query );
	const { records, count, page } = get( state, [ queryKey ], {} );

	switch ( action.type ) {
		case 'SET_AVAILABILITY':
			const currentAvailability = records || [];

			return merge( {}, state, {
				[ queryKey ]: {
					records: [
						...currentAvailability,
						...action.availability,
					],
					count: action.count,
					page: page || 1,
				},
			} );
		case 'SET_AVAILABILITY_ERROR':
			return merge( {}, state, {
				[ queryKey ]: ERROR,
			} );
		case 'NEXT_AVAILABILITY_PAGE':
			const currentPage = page || 1;

			const nextPage = currentPage + 1;
			return merge( {}, state, {
				[ queryKey ]: {
					records,
					count,
					page: nextPage,
				},
			} );
	}

	return state;
}

